// src/animations/variants.js

import { transform } from "framer-motion";

/**
 * Shared animation variants with configurable delay and stagger
 */
export const containerVariants = {
  hidden: {},
  visible: (custom = {}) => ({
    transition: {
      // delay before first child animates
      delayChildren: custom.delayChildren ?? 0,
      // time between each child's animation start
      staggerChildren: custom.staggerChildren ?? 0.12,
    },
  }),
};

export const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30,
    transform: "scale(0.9)",
    transition: { duration: 0.2 },
  },
  visible: {
    opacity: 1,
    y: 0,
    transform: "scale(1)",
    transition: { duration: 0.2 },
  },
};
